var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGirl = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "M_T_D_Icon_Gender",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-girl{fill:#fda9e2}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_362",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fee2f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Girl",
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    d: "M319.24 301.911a.849.849 0 0 0-.848.849v.993a.848.848 0 0 0 1.7 0v-.993a.849.849 0 0 0-.852-.849z",
    className: "cls-girl",
    transform: "translate(-312.648 -289.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    d: "M398.94 303.751v-.993a.848.848 0 1 0-1.7 0v.993a.848.848 0 1 0 1.7 0z",
    className: "cls-girl",
    transform: "translate(-384.684 -289.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    d: "M343.587 344.249a1.811 1.811 0 0 1-2.557 0 .636.636 0 1 0-.9.9 3.084 3.084 0 0 0 4.357 0 .636.636 0 1 0-.9-.9z",
    className: "cls-girl",
    transform: "translate(-332.308 -328.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    d: "M306.388 335.993h-.66a.636.636 0 0 0 0 1.273h.66a.636.636 0 1 0 0-1.273z",
    className: "cls-girl",
    transform: "translate(-300.496 -321.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    d: "M409.059 335.993h-.66a.636.636 0 0 0 0 1.273h.66a.636.636 0 0 0 0-1.273z",
    className: "cls-girl",
    transform: "translate(-394.29 -321.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    d: "M282.789 201.159a.88.88 0 0 0 1.2-.261 6.974 6.974 0 0 1 11.631 0 .88.88 0 0 0 1.2.261.837.837 0 0 0 .267-1.171 8.732 8.732 0 0 0-14.561 0 .837.837 0 0 0 .263 1.171z",
    className: "cls-girl",
    transform: "translate(-279.802 -193.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    d: "M261.93 162.921a10.011 10.011 0 0 0-10 10v9.854a1.859 1.859 0 0 0 1.322 1.8 1.947 1.947 0 0 0 .586.091 1.856 1.856 0 0 0 1.531-.811l1.14-1.631a8.553 8.553 0 0 0 10.842 0l1.14 1.631a1.89 1.89 0 0 0 3.438-1.083v-9.854a10.011 10.011 0 0 0-9.999-9.997zm0 1.726a8.285 8.285 0 0 1 8.258 7.76 12.7 12.7 0 0 1-7.7-2.959.863.863 0 0 0-1.11 0 12.7 12.7 0 0 1-7.7 2.959 8.285 8.285 0 0 1 8.252-7.76zm-7.976 18.222a.164.164 0 0 1-.3-.094v-4.946a8.554 8.554 0 0 0 1.616 3.155zm7.976-.431a6.852 6.852 0 0 1-6.844-6.845v-1.573a14.432 14.432 0 0 0 6.844-2.807 14.431 14.431 0 0 0 6.845 2.807v1.574a6.852 6.852 0 0 1-6.845 6.844zm8.16.493a.147.147 0 0 1-.184-.062l-1.318-1.885a8.55 8.55 0 0 0 1.616-3.155v4.946a.148.148 0 0 1-.114.157z",
    className: "cls-girl",
    transform: "translate(-251.93 -162.921)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGirl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-girl.9d6fc6c7.svg";
export { ForwardRef as ReactComponent };